/**
 * Reads the business error code out of a failed request.
 *
 * `error.response` is undefined for network errors, timeouts and cancellations,
 * so reading `error.response.data.code` directly throws a TypeError from inside
 * the catch block and skips whatever cleanup follows it - leaving the form stuck
 * on its spinner and the user resubmitting.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getErrorCode = (error: any): string | undefined => error?.response?.data?.code;
